import apiTariff from '@/api/tariff'
import {propOr} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null
}

export const mutationTypes = {
  getTariffListStart: '[tariff list] Get tariff list start',
  getTariffListSuccess: '[tariff list] Get tariff list success',
  getTariffListFailure: '[tariff list] Get tariff list failure'
}

export const actionTypes = {
  getTariffList: '[tariff list] Get trainer'
}

const mutations = {
  [mutationTypes.getTariffListStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTariffListSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 100
    state.isLoading = false
  },

  [mutationTypes.getTariffListFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.getTariffList](context, data) {
    const params = propOr(null, 'params', data)
    context.commit(mutationTypes.getTariffListStart)
    return new Promise(resolve => {
      apiTariff
        .getTariffList(params)
        .then(response => {
          context.commit(mutationTypes.getTariffListSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getTariffListFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
